import React from "react";
import ServiceTemplate from "../../components/templates/ServiceTemplate";
import healthplansBg from "../../assets/images/produtos/saude.webp";

const HealthPlans = () => {
  const serviceData = {
    heroImage: healthplansBg,
    title: "Planos de Saúde",
    artigo: "um",
    subtitle:
      "Cuide da saúde de sua família com os melhores planos e redes credenciadas",
    color: "red",
    icon: "heartbeat",
    ramo: "Plano de Saúde",
    pageRamo: true,
    showEmail: true,
    showVeiculo: false,
    formUrl:
      "https://docs.google.com/forms/d/e/1FAIpQLScQc-SPygWVNQn0Zl1IUIqvtMl73Xa1sa_6qW7IaBalG3J5Ug/formResponse",
    mainContent: [
      "Os planos de saúde são essenciais para garantir acesso a cuidados médicos de qualidade para você e sua família. Com um plano de saúde da Free Market Seguros, você tem a tranquilidade de contar com atendimento médico quando precisar, sem se preocupar com custos elevados de consultas, exames e internações.",
      "Trabalhamos com as principais operadoras do mercado para oferecer a você as melhores coberturas com preços competitivos, garantindo o melhor custo-benefício para seu perfil e necessidades.",
    ],
    coverages: [
      "Consultas médicas em diversas especialidades",
      "Exames laboratoriais e de imagem",
      "Internações hospitalares",
      "Cirurgias e procedimentos",
      "Atendimento de urgência e emergência",
    ],
    additionalCoverages: [
      "Cobertura odontológica",
      "Terapias complementares",
      "Atendimento domiciliar",
      "Cobertura nacional",
      "Reembolso para procedimentos fora da rede",
    ],
    advantages: [
      {
        icon: "hospital",
        title: "Ampla Rede Credenciada",
        description:
          "Acesso a hospitais, clínicas e laboratórios de referência em todo o país",
      },
      {
        icon: "user-md",
        title: "Especialidades Médicas",
        description:
          "Atendimento com médicos especialistas nas mais diversas áreas da saúde",
      },
      {
        icon: "hand-holding-medical",
        title: "Atendimento Personalizado",
        description:
          "Planos adaptados às necessidades específicas de cada cliente e família",
      },
    ],
    steps: [
      {
        title: "Análise de Perfil",
        description:
          "Avaliamos seu perfil, necessidades e orçamento para identificar as melhores opções de planos.",
      },
      {
        title: "Apresentação de Opções",
        description:
          "Apresentamos as operadoras e planos mais adequados, com comparativo detalhado de coberturas e custos.",
      },
      {
        title: "Contratação Simplificada",
        description:
          "Após escolher o plano ideal, cuidamos de toda a burocracia para agilizar sua contratação.",
      },
      {
        title: "Suporte Contínuo",
        description:
          "Oferecemos suporte durante toda a vigência do plano, auxiliando em dúvidas, reembolsos e autorizações.",
      },
    ],
    tip: "Ao escolher um plano de saúde, considere não apenas o valor da mensalidade, mas também a rede credenciada, cobertura de procedimentos e valores de coparticipação. Um plano mais barato pode não ser vantajoso se não atender suas necessidades específicas de saúde.",
  };

  return <ServiceTemplate {...serviceData} />;
};

export default HealthPlans;
